// extracted by mini-css-extract-plugin
export default {"table-cell":"TableSkeleton_table-cell__F3NaT","tr":"TableSkeleton_tr__EWmyr","table-row":"TableSkeleton_table-row__CjLLf"};